import React, { useState, useEffect, useRef } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch, useSelector } from "react-redux";
import { getSequnceSort } from "../../../../utils/helper";
import { showModal } from "../../../../redux/actions";
import * as image from "../../../../resources/images";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getDimModuleChallngObj } from "../../../../redux/actions/APIs";
import { ShimmerCategoryList } from "react-shimmer-effects";
const LessonModuleChallenge = ({ setModuleINdex, moduleIndex }) => {
	const param = useParams();
	const dispatch = useDispatch();
	const {
		socialActivityData,
		dimModuleObjResp,
	} = useSelector((state) => state.collections);

	const [activityData, setActivityData] = useState();


	useEffect(() => {
		dispatch(
			getDimModuleChallngObj(
				param?.id,
				param?.activityId,
				param?.courseId,
			)
		);
	}, [])

	useEffect(() => {
		if (dimModuleObjResp?.records?.length > 0) {
			setActivityData(dimModuleObjResp?.records[0]);
		} else {
			setActivityData();
		}
	}, [dimModuleObjResp])

	const handleModule = (modInd) => {
		setModuleINdex(modInd);
	}

	console.log("LessonModuleChallenge : ", dimModuleObjResp);
	return (
		<>
			{dimModuleObjResp?.records?.length > 0 ? (
				<>
				<div className="CourseCardWrapper fullHeight100">
					<div className="Course_height">
						<div class="gridSection">
							<div className="planprogresdash flex align-items-start">
								<div class="planprogress_list w-50 p-0">
									<table class=" badgesdetails_card d-block">
										<tr>
											<td>
												<div class="clbcarddtl p-3">
													<div class="lbuserdtl">
														<div class="lbuserimage text-center">
															{activityData?.badge?.imageUrl ? (
																<img src={activityData?.badge?.imageUrl} alt="" />
															) : (
																<img src={image.animal_badgesdefault} alt="" />
															)}
														</div>
														<div class="lbuserName pb-2">
															<h4 className="text-center">{activityData?.badge?.badgesName}</h4>
															{/* <p className="p-0 mt-2">
																<strong>
																	<img
																		src="/static/media/mortarboard.ef1b753378e48b5a9009.png"
																		class="mr-2"
																	/>
																</strong>{" "}
																{activityData?.badge?.courseName}
															</p>
															<p className="mt-1">
																<strong></strong>{activityData?.badge?.activityName}
															</p> */}
															<p>
																{/* <strong className="d-block">About Badge:</strong> */}

																{activityData?.badge?.bragAboutIt}
															</p>
															<p>
																{/* <strong className="d-block">Description:</strong> */}
																{activityData?.badge?.description}
															</p>
														</div>
													</div>
												</div>
											</td>
										</tr>
									</table>
								</div>
								<div className="module_objective w-50 p-0">
									<div class="plans_contents_ pl-3 px-3">
										{/* <h3 class="mb-2 mt-3">
											<span class="_module_name">C1</span>
											{activityData?.badge?.courseName}
										</h3>
										<h4 class="mb-2">
											<span class="_module_name">M1</span>
											{activityData?.badge?.activityName}
										</h4>
										<div className="tabgrid mt-3">
											<ul class="objectibe_module_list flex">
												{activityData?.activityObjectives?.map((module, index) => (
													<li className={`${moduleIndex === index ? "active-tabs" : ""} pointer tabs w-25 justify-content-center`}
														onClick={() => handleModule(index)}>
														M{index + 1}
													</li>
												))}
											</ul>
										</div> */}
										<h4 class="mb-3 flex">
											Module Objectives{" "}
											<span class="Score_points">
												<span class="earnnoCoin">{activityData?.points ? activityData?.points : 0}</span>
												<img src={image.money_bag}></img>
											</span>
										</h4>
										<ul>
											{activityData?.objectives?.map((modObj, key) => (
												<li class="d-flex">
													<div class="obj_prog_ress">
														<span class="Progresslistitem m-0">
															<span
																class="diemensionalProgress progressbar1"
																style={{
																	maxWidth: `${modObj?.progress}%`,
																	background: "rgb(32, 201, 151)",
																}}
															></span>
															<span
																class="percentage_marker"
																style={{ left: `${modObj?.progress}%` }}
															>
																{modObj?.progress}<sub>%</sub>
															</span>
														</span>
													</div>
													<span class="">
														{modObj?.content}
													</span>
												</li>
											))}
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="LeftPanelFooter input-group full-Width-group basic_details_form pagebuttonStrip "><div class="form-group BDsubmitbutton d-flex justify-content-between align-items-center m-0 "></div></div>
		       </>
			) : (
				<div>
					<ShimmerCategoryList items={4} categoryStyle="STYLE_SIX" />
				</div>
			)}

		</>
	);
};
export default LessonModuleChallenge;
